var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsCloseSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#262e33;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-396 -552)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(396 552)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.736,8.345,6.6,22.484a.93.93,0,0,1-1.316-1.315l6.412-6.412L5.281,8.345A.93.93,0,0,1,6.6,7.029l6.412,6.412L19.42,7.029a.93.93,0,0,1,1.315,1.316Zm-5.314,7.51L14.106,17.17l5.314,5.314a.93.93,0,1,0,1.315-1.315Z",
    transform: "translate(395.211 549.243)",
    fill: "#262e33"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCloseSmall);
export default __webpack_public_path__ + "static/media/icons-close-small.12e5bc0d.svg";
export { ForwardRef as ReactComponent };